export var auto_init_show_more = function () {
    document.querySelectorAll('.ac-show-more').forEach(function (el) {
        new ShowMore(el);
    });
};
var ShowMore = /** @class */ (function () {
    function ShowMore(el) {
        this.element = el;
        this.initEvents();
    }
    ShowMore.prototype.initEvents = function () {
        var _this = this;
        if (this.isInited()) {
            return;
        }
        if (this.getToggler()) {
            this.getToggler().addEventListener('click', function (event) {
                event.preventDefault();
                event.stopPropagation();
                _this.toggle();
            });
        }
        this.element.dataset.showMoreInit = 'true';
    };
    ShowMore.prototype.getToggler = function () {
        return this.element.querySelector('.ac-show-more__toggle');
    };
    ShowMore.prototype.isInited = function () {
        return this.element.dataset.showMoreInit === 'true';
    };
    ShowMore.prototype.toggle = function () {
        if (this.element.classList.contains('-on')) {
            this.hide();
        }
        else {
            this.show();
        }
    };
    ShowMore.prototype.show = function () {
        this.element.classList.add('-on');
        this.getToggler().innerHTML = this.getToggler().dataset.less;
    };
    ShowMore.prototype.hide = function () {
        this.element.classList.remove('-on');
        this.getToggler().innerHTML = this.getToggler().dataset.more;
    };
    return ShowMore;
}());
export default ShowMore;
